import { connect } from 'react-redux'
import UI from './UI'
import { setSearchTermAction, setSearchPageDataAction } from './store'
import { push } from 'connected-react-router'
import { decorateUrl } from '../UTMscript'
import { ProfileTypes } from 'constants/'

const mapStateToProps = ({ search, user, referential, marketing, config }) => ({
  Tags: search.Tags,
  Courses: search.Courses,
  Authors: search.Authors,
  LearningPaths: search.LearningPaths,
  searchTerm: search.searchTerm,
  searchTermsHistory: search.searchTermsHistory,
  profileType: user?.ProfileType ? ProfileTypes[referential?.ProfileTypes[user.ProfileType]] : null,
  topBarOpen: marketing.topBarOpen,
  bannerOpen: config.banner
})

const mapDispatchToProps = dispatch => ({
  setSearchTerm: (searchTerm, isSearchPage, fillSearchPage) => dispatch(setSearchTermAction(searchTerm, isSearchPage, fillSearchPage)),
  goToLink: link => dispatch(push(decorateUrl(link))),
  setSearchPageData: () => dispatch(setSearchPageDataAction())
})

export default connect(mapStateToProps, mapDispatchToProps)(UI)
